export default "__VITE_ASSET__CuqeBxTM__"